import { useForm } from 'react-hook-form'

import { yupResolver } from '@hookform/resolvers/yup'
import { TextInput } from '@ui/components/core/TextInput'
import { DynamicFormProps } from '@ui/interfaces'
import { SaveAndCancelButtons } from '@ui/pages/pipelinesWorkflow/components/DestinationForms/SaveAndCancelButtons'
import * as Yup from 'yup'

const schema = Yup.object({
  endpoint: Yup.string().required('Elastic APM Server Endpoint is required'),
  elasticApmSecretToken: Yup.string().required('Elastic APM Secret Token is required'),
}).required()

export default function Elasticsearch(props: DynamicFormProps) {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      ...props.config,
    },
  })

  const { saveClick, cancelClick } = props

  return (
    <form onSubmit={handleSubmit(saveClick)}>
      {props.additionalInputs}
      <div>
        <TextInput
          label="Elastic APM Server Endpoint*"
          placeholder="elastic-apm-server:8200"
          disabled={props.disableInputs}
          register={register}
          name="endpoint"
          error={errors['endpoint']?.message}
        />
        <TextInput
          label="Elastic APM Secret Token*"
          placeholder="abcd1234"
          disabled={props.disableInputs}
          register={register}
          name="elasticApmSecretToken"
          error={errors['elasticApmSecretToken']?.message}
        />
        {props.submitButton ? props.submitButton : <SaveAndCancelButtons cancelClick={cancelClick} />}
      </div>
    </form>
  )
}
